import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=a181f76a&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a181f76a')) {
      api.createRecord('a181f76a', component.options)
    } else {
      api.reload('a181f76a', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=a181f76a&", function () {
      api.rerender('a181f76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/waschepacket.vue"
export default component.exports